import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import ui from '../data/ui.json';
export default () =>
  muster()
    .path('consolidatesetup.getData', {
      call: async ({ req }, { get, set, call }) => {
        console.log("inside consolidation muster");
        await set('consolidatesetup.loading', true);
        const oReturn = await getValues(get(`roster.data.consolidatesetup.getData`));
        await set('consolidatesetup.loading', false);
        const parsedData=JSON.parse(oReturn);
        await set('consolidatesetup.consolidationData', parsedData);

      },
    })
   .path('consolidatesetup.setData', {
     call: async ({ req }, { set, get, call }) => {
      //  In future if for portfolio length less than 300 and if we have to give call to roster then following code should be used.

       // const {branchCode, pfId, relId  } = req.args[0];
       // const branchCodeStr =JSON.stringify(branchCode);
       // const pfIdStr =JSON.stringify(pfId).replace(/\"/g, "\'");
       // const [oReturn] = await getValues(get(`roster.data.consolidatesetup.setData["${branchCodeStr}"]["${pfIdStr}"]["${relId}"]`));
       // const [oReturn, _portfolioLength] =  await getValues(get([
       //   `roster.data.consolidatesetup.setData["${branchCodeStr}"]["${pfIdStr}"]["${relId}"]`,
       //   `roster.data.portfolios.length`
       // ]));
       // await set('app.user.portfolios.length', _portfolioLength);
       // await set('consolidatesetup.result', oReturn);
       set('app.user.cacheId', Date.now());
       const [data] = await getValues(get(`roster.data.portfolios.getData`));
       const portfolioData = await JSON.parse(data);
       await set('app.user.portfolios', portfolioData);
       const topPortfolio = portfolioData[0];
       const portfolioId = topPortfolio.id;
       const title = topPortfolio.title;
       const referenceCurrency = topPortfolio.referenceCurrency;
       const relId = topPortfolio.relId;
       const relIdType = topPortfolio.relIdType;
       const pfType = topPortfolio.pfType;
       const branchCode = topPortfolio.branchCode;
       const portfolio = { id: portfolioId, title, referenceCurrency, relId, relIdType, pfType, branchCode };
       await set('consolidatesetup.btnLoading', false);
       await set('app.user.selectedPortfolioId', portfolioId);
       await set('app.user.selectedPortfolioData', portfolio);
       await call('ui.history.push', { pathname: '/portfolios' }, true);
       set('userprofile.prefCurrency', undefined)
       await call('auth.getPFData'); // WMCCE-4443 Get pf-relId mapping for BP Consolidation
       const [_portfolioLength] = await getValues(get([`roster.data.portfolios.length`]));
       await set('app.user.portfolios.length', _portfolioLength);
     },
    })
    .path('consolidatesetup.consolidationData', variable())
    .path('consolidatesetup.result', variable())
    .path('consolidatesetup.loading', variable())
    .path('consolidatesetup.btnLoading', variable());